import loadable from '@loadable/component';
import React from 'react';
import { Route, Switch } from 'react-router';

import { NotFound } from 'src/modules/designStudio/components/NotFound';
import { Route as Routes } from 'src/shared/route';

import { Mode } from '../../providers';

const DesignStudio = loadable(() => import('../DesignStudio'), {
  resolveComponent: module => module.DesignStudio,
});

const Router = () => (
  <Switch>
    <Route path={Routes.DESIGN_STUDIO_GUEST.path}>
      <DesignStudio mode={Mode.GUEST} />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_PREVIEW.path}>
      <DesignStudio mode={Mode.PREVIEW} />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_SHARE_VIEW.path}>
      <DesignStudio mode={Mode.SHARE} />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_PRO_VIEW.path}>
      <DesignStudio mode={Mode.PRO_VIEW} />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_EDIT.path}>
      <DesignStudio mode={Mode.DEFAULT} />
    </Route>
    <Route path={Routes.RENDERINGS_INTERACTIVE.path}>
      <DesignStudio mode={Mode.INTERACTIVE_RENDERING} />
    </Route>
    <Route path="*">
      <NotFound />
    </Route>
  </Switch>
);

export { Router };
